module.exports = __webpack_public_path__ + "fonts/rubik-light-webfont.7c94973f.7c94973f.eot";